import { useState } from 'react';

import { useLocation } from '@tanstack/react-router';

import { Header } from '@/components/layout/header';
import { Sidebar } from '@/components/layout/sidebar';

export const MainLayout = ({
  children,
  showSidebar = true,
}: {
  children: React.ReactNode;
  showSidebar?: boolean;
}) => {
  const [isVisible, setVisible] = useState(false);
  const location = useLocation();

  const closeMobileSidebarMenu = () => {
    setVisible(false);
  };

  return (
    <div className="relative flex h-screen flex-col overflow-hidden bg-background-lighter">
      <Header isVisible={isVisible} onClick={setVisible} />
      <div className="flex h-[calc(100vh-60px)] flex-1 bg-background-lighter p-0 sm:px-2 sm:pt-4 lg:pl-6">
        {showSidebar ? (
          <Sidebar closeMobileSidebarMenu={closeMobileSidebarMenu} isVisible={isVisible} />
        ) : null}
        <button
          type="button"
          onClick={closeMobileSidebarMenu}
          className={`${isVisible ? 'h-[calc(100vh-60px)] max-md:absolute max-md:bottom-0 max-md:z-30 max-md:w-full max-md:bg-black max-md:opacity-50' : 'hidden'}`}
        />
        <main
          key={location.pathname}
          className="flex flex-1 flex-col overflow-auto px-4 py-4 max-md:px-2 sm:px-2 sm:py-0 lg:pl-6 lg:pr-[13px]"
        >
          {children}
        </main>
      </div>
    </div>
  );
};
